import Nested from './nested.vue'
import { createRouter, createWebHashHistory } from "vue-router"
import store from '../store'

Promise.all([store.dispatch('getSiteConfig')])

//路由组
let routes = [
    // 首页
    {
        path: '/',
        alias: '/index',
        name: 'index',
        component: () => import('../views/Home'),
        meta: { title: '首页', keepAlive: 'index' }
    },
    {
        path: '/search/:t',
        name: 'search',
        component: () => import('../components/Search'),
        meta: { title: '搜索', keepAlive: 'search'}
    },
    // 专题
    {
        path: "/special",
        name: 'special',
        //component: () => import('../components/special/level_1_list'),
        component: Nested,
        meta: { title: '一级专题列表', keepAlive: 'special_list_1'},
        children: [
            {
                path: 'all',
                name: 'special.list1',
                component: () => import('../components/special/level_1_list'),
                meta: { title: '二级专题列表', keepAlive: 'special_list_2'},
            },
            {
                path: ':special_class(\\d+)',
                name: 'special.list2',
                component: () => import('../components/special/level_2_list'),
                meta: { title: '二级专题列表', keepAlive: 'special_list_2'},
            },
            /*{
                path: ':special_class(\\d+)/:special_id(\\d+)',
                name: 'content1.list1',
                component: () => import('../components/special/detail'),
                meta: { title: '专题内容', keepAlive: 'special_detail'},
            }*/
        ]
    },
    // 普通内容
    {
        path: '/article',
        name: 'content',
        component: Nested,
        children: [
            /* 一级列表 */
            {
                path: ':column',
                name: 'content1.list1',
                component: () => import('../components/list'),
                meta: { title: '一级列表', keepAlive: 'list1'},
                children: [
                    /* 二级列表 */
                    {
                        path: ':sub_column',
                        name: 'content2.list2',
                        component: () => import('../components/list'),
                        meta: { title: '二级列表', keepAlive: 'list2'},
                    },
                ]
            },
            /* 一级内容 */
            {
                path: ':column/:id(\\d+)',
                name: 'content1.detail1',
                component: () => import('../components/detail'),
                meta: { title: '一级内容', keepAlive: 'detail1'},
            },
            /* 二级内容 */
            {
                path: ':column/:sub_column/:id(\\d+)',
                name: 'content2.detail2',
                component: () => import('../components/detail'),
                meta: { title: '一级内容', keepAlive: 'detail1'},
            }
        ]
    },
    {
        path: '/message',
        name: 'message',
        component: Nested,
        meta: { title: '留言板', keepAlive: 'message_lists'},
        children: [
            {
                path: '',
                name: 'message.list',
                component: () => import('../components/message/list')
            }
        ]
    }
    /*{
        path: '/:column',
        name: 'content',
        component: Nested,
        children: [
            /!* 列表 *!/
            {
                path: ':sub_column',
                name: 'content.list',
                component: () => import('../components/list'),
                meta: { title: '列表', keepAlive: 'list'}
            },
            /!* 内容 *!/
            {
                path: ':sub_column?/:id',
                name: 'content.detail',
                component: () => import('../components/detail'),
                meta: { title: '内容', keepAlive: 'detail'}
            }
        ]
    }*/
]
/*const routes = [
    {
        path: '/',
        redirect: '/home',
    },

    {
        path: '/home',
        component: Home,
        name: '首页',
    },
    {
        path: "/:plate",
        component: Content,
        name: '文章',
        children: [
            {
                path: ":page",
                component: Article,
                name: '文章列表',
            },
            {
                path: ":page/:id",
                component: Detail,
                name: '文章详细',
            },
        ],
    },
    {
        path: "/search",
        component: Content,
        children: [
            {
                path: "result/:sign",
                component: Search,
            }
        ]
    },
    {
        path: '/image',
        component: Content,
        desc: '图片',
        children: [
            {
                path: ":id",
                component: Image,
            },
            {
                path: ":id/:id",
                component: Detail,
            },

        ],
    },
    {
        path: '/singlepage',
        component: SinglePage,
        desc: '单页'
    },
    {
        path: '/404',
        name: 'notFound',
        component: NotFound
    },
    {
        path: '/:pathMatch(.*)',
        redirect: '/404'
    }
]*/

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router
